import CategoryIcon from '@material-ui/icons/Category';
import OrganizationList from './OrganizationList';
import OrganizationCreate from './OrganizationCreate';

export default {
    list: OrganizationList,
    create: OrganizationCreate,
    icon: CategoryIcon,
};
